'use client';

import { createContext, useCallback, useState, type ReactNode } from 'react';

export type DialogType = 'auth' | 'upgrade' | 'subscribe' | null;
type DialogPayload = Record<string, unknown> | null;

type DialogContextValue = {
  openDialog: (
    type: Exclude<DialogType, null>,
    payload?: DialogPayload,
  ) => void;
  closeDialog: () => void;
  currentDialog: DialogType;
  dialogPayload: DialogPayload;
};

export const DialogContext = createContext<DialogContextValue | undefined>(
  undefined,
);

export const DialogProvider = ({ children }: { children: ReactNode }) => {
  const [currentDialog, setCurrentDialog] = useState<DialogType>(null);
  const [dialogPayload, setDialogPayload] = useState<DialogPayload>(null);

  const openDialog = useCallback(
    (type: Exclude<DialogType, null>, payload: DialogPayload = null) => {
      setCurrentDialog(type);
      setDialogPayload(payload);
    },
    [setCurrentDialog, setDialogPayload],
  );

  const closeDialog = () => {
    setCurrentDialog(null);
    setDialogPayload(null);
  };

  return (
    <DialogContext.Provider
      value={{ currentDialog, dialogPayload, openDialog, closeDialog }}
    >
      {children}
    </DialogContext.Provider>
  );
};
